export const brandIdentity = {
  title: 'Identidad de Marca',
  subtitle: 'Configura tu identidad visual para imágenes generadas por IA',

  form: {
    colors: {
      title: 'Colores de Marca',
      subtitle: 'Define la paleta de colores de tu marca',
    },
    primaryColor: {
      label: 'Color Primario',
      placeholder: '#3B82F6',
    },
    secondaryColor: {
      label: 'Color Secundario',
      placeholder: '#6366F1',
    },
    accentColor: {
      label: 'Color de Acento',
      placeholder: '#F59E0B',
    },
    additionalColors: {
      label: 'Colores Adicionales',
      add: 'Agregar color',
      placeholder: '#RRGGBB',
    },
    typography: {
      title: 'Tipografía',
      subtitle: 'Fuentes utilizadas en tu marca',
    },
    primaryFont: {
      label: 'Fuente Primaria',
      placeholder: 'ej., Inter, Helvetica',
    },
    secondaryFont: {
      label: 'Fuente Secundaria',
      placeholder: 'ej., Georgia, Merriweather',
    },
    logo: {
      title: 'Logo de Marca',
      subtitle: 'Sube tu logo para marca de agua en imágenes',
      upload: 'Subir logo',
      change: 'Cambiar logo',
      formats: 'Se recomienda PNG, SVG o WebP',
    },
    guidelines: {
      title: 'Directrices de Marca',
      subtitle: 'Instrucciones para la generación de imágenes por IA',
      placeholder:
        'ej., Usar estilo minimalista, evitar fondos recargados, preferir estética moderna y limpia...',
    },
    colorInvalid: 'Debe ser un color hex válido (ej. #FF5500)',
    save: 'Guardar',
    saving: 'Guardando...',
  },

  preview: {
    title: 'Vista Previa',
    colorPalette: 'Paleta de Colores',
    fonts: 'Tipografía',
    primary: 'Primario',
    secondary: 'Secundario',
    accent: 'Acento',
  },

  playground: {
    title: 'Playground de Imágenes',
    subtitle: 'Prueba cómo se ve tu identidad de marca en imágenes generadas por IA',
    titleLabel: 'Título de la imagen',
    titlePlaceholder: 'ej., Cómo mejorar la seguridad digital',
    styleLabel: 'Estilo visual',
    promptLabel: 'Prompt personalizado (opcional)',
    promptPlaceholder: 'ej., Minimalista, fondo limpio, enfoque tecnológico',
    generate: 'Generar Imagen',
    generating: 'Generando...',
    referenceImages: {
      label: 'Imágenes de referencia',
      subtitle: 'Sube 1-3 imágenes para replicar su estilo visual',
      dropzone: 'Haz clic o arrastra imágenes aquí',
      maxReached: 'Máximo 3 imágenes',
      tooLarge: 'La imagen debe ser menor a 5MB',
      invalidType: 'Solo se permiten archivos de imagen',
    },
    galleryPicker: {
      label: 'Imágenes de referencia guardadas',
      subtitle: 'Selecciona hasta 3 imágenes de tu galería',
      empty: 'Sin imágenes guardadas',
    },
  },

  referenceGallery: {
    title: 'Imágenes de Referencia',
    subtitle: 'Sube imágenes de plantilla para replicar su estilo visual en contenido generado',
    upload: 'Subir imagen',
    empty: 'Sin imágenes de referencia',
    emptySubtitle: 'Sube imágenes para usar como plantillas de estilo visual',
    deleteConfirm: '¿Eliminar esta imagen de referencia?',
    maxReached: 'Máximo 10 imágenes alcanzado',
    tooLarge: 'La imagen debe ser menor a 5MB',
    invalidType: 'Solo se permiten archivos de imagen',
  },

  toast: {
    saveSuccess: 'Identidad de marca guardada correctamente',
    saveError: 'Error al guardar identidad de marca: {{message}}',
    logoSuccess: 'Logo subido correctamente',
    logoError: 'Error al subir logo: {{message}}',
    playgroundError: 'Error al generar imagen: {{message}}',
    referenceImageUploadSuccess: 'Imagen de referencia subida',
    referenceImageUploadError: 'Error al subir imagen de referencia: {{message}}',
    referenceImageDeleteSuccess: 'Imagen de referencia eliminada',
    referenceImageDeleteError: 'Error al eliminar imagen de referencia: {{message}}',
  },
} as const
